export const HomePageExplore = [
  {
    tag: "New to coding",
    courses: [
      {
        heading: "Python Basics",
        description:
          "Learn the fundamentals of Python programming language, including variables, data types, control structures, and functions.",
        level: "Beginner",
        lessionNumber: 8,
      },
      {
        heading: "JavaScript Fundamentals",
        description:
          "Explore the basics of JavaScript programming language, covering variables, functions, arrays, and objects.",
        level: "Beginner",
        lessionNumber: 10,
      },
      {
        heading: "Introduction to Git",
        description:
          "Learn the essentials of version control using Git, including repository management, branching, and merging.",
        level: "Beginner",
        lessionNumber: 6,
      },
    ],
  },

  {
    tag: "Skills paths",
    courses: [
      {
        heading: "React.js",
        description:
          "Master building user interfaces with React.js library, covering components, state management, and routing.",
        level: "Intermediate",
        lessionNumber: 12,
      },
      {
        heading: "Node.js",
        description:
          "Dive into server-side JavaScript with Node.js, covering asynchronous programming, file system operations, and HTTP servers.",
        level: "Intermediate",
        lessionNumber: 10,
      },
      {
        heading: "MongoDB",
        description:
          "Explore NoSQL database management with MongoDB, covering CRUD operations, indexing, and aggregation.",
        level: "Intermediate",
        lessionNumber: 8,
      },
    ],
  },
  {
    tag: "Career paths",
    courses: [
      {
        heading: "Full-Stack Web Development",
        description:
          "Become proficient in both front-end and back-end development, covering HTML, CSS, JavaScript, Node.js, and React.js.",
        level: "Advanced",
        lessionNumber: 20,
      },
      {
        heading: "Data Science with Python",
        description:
          "Learn data analysis and machine learning techniques using Python libraries such as NumPy, Pandas, and Scikit-learn.",
        level: "Advanced",
        lessionNumber: 18,
      },
      {
        heading: "DevOps Fundamentals",
        description:
          "Master DevOps practices including continuous integration, continuous deployment, and infrastructure automation.",
        level: "Advanced",
        lessionNumber: 16,
      },
    ],
  },
];
